import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SocialLinkedinIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialLinkedin",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M5.38 2.59h-.22C3.44 2.59 2.04 3.97 2 5.68c0 1.73 1.4 3.13 3.12 3.13h.22A3.128 3.128 0 0 0 8.81 5.7c0-1.73-1.4-3.13-3.13-3.13-.1 0-.2 0-.3.01h.01l-.01.02Zm2.98 26.84V11.36H2.32v18.07h6.03Zm21.64 0V19.02c0-5.55-2.98-8.11-6.94-8.11h-.26c-2.22 0-4.15 1.22-5.16 3.03l-.02.03h.05v-2.6h-6s.09 1.68 0 18.07h6.01V19.06c0-.44.07-.87.21-1.27v.03a3.27 3.27 0 0 1 3.08-2.15c2.15 0 3.03 1.64 3.03 4.1v9.68h5.99Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.16 2H5.27C3.47 2 2 3.46 2 5.27v20.9c0 1.8 1.46 3.26 3.27 3.26h20.9c1.8 0 3.26-1.46 3.26-3.26V5.27c0-1.8-1.46-3.27-3.27-3.27M10.49 12.45v12.41H6.57V12.45zM6.57 8.84c0-.91.78-1.61 1.96-1.61s1.91.7 1.96 1.61c0 .91-.73 1.65-1.96 1.65s-1.96-.74-1.96-1.65m18.29 16.02h-3.92v-6.53c0-1.31-.65-2.61-2.29-2.64h-.05c-1.58 0-2.23 1.34-2.23 2.64v6.53h-3.92V12.45h3.92v1.67s1.26-1.67 3.79-1.67 4.7 1.78 4.7 5.39v7.01Z"
      })
    })
  }));
};
SocialLinkedinIcon.displayName = 'SocialLinkedinIcon';